import React, { Component } from 'react';
import Gallery from './Gallery.js'
import { ethers } from 'ethers'

import Pandu from '../artifacts/contracts/Pandu.sol/Pandu.json'     //Contract ABI

const contractAddress = "0x3D5ff826b3CAcE561028Ed5C6174C62e8e2bEB60"    //Minting contract address


class Sale extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            max_tokens: 0,
            max_purchase: 10,
            current_supply: 0,
            current_price: 0.055,
            is_sale_active: false,
        };
        this.onClickHandler = this.onClickHandler.bind(this);
        this.updateInput = this.updateInput.bind(this);
        this.setminting = this.setminting.bind(this)
    }

    onClickHandler(evt) {
        evt.preventDefault();
        if (!isNaN(parseInt(this.state.value))) {
            this.setminting(parseInt(this.state.value))  //sending mint transaction with input amount
        }
    }

    updateInput(evt) {      //Input event handler
        this.state = { value: evt.target.value };     
    }

    async setminting(amt) {     //Sending Transaction
        if (typeof window.ethereum == 'undefined') {  // && window.ethereum.isMetaMask
            console.log('Wallet not connected')
        }
        else {      //Write Contract
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(contractAddress, Pandu.abi, signer);
            try {
                let overrides = { value: ethers.utils.parseEther((amt * 0.055).toString()) };
                const transaction = await contract.mint(amt, overrides);
                await transaction.wait()

            } catch (err) {
                console.log("Error: ", err)
            }
        }

    }

    saleInactive() {
        return (
            <div>
                <Gallery windowSize="300px" gallerySize="8000px" />
                <div className='lato-black text-center text-light'>
                    <span className="text-mint">Sale is </span>Inactive<br />
                    <div className="text-cream lato-regular"><small style={{fontWeight: 300}}>Will be live soon...</small></div>
                </div>
            </div>
        )
    }

    saleActive() {
        return (
            <div>
                <Gallery windowSize="250px" gallerySize="7000px" />
                <div className="lato-black text-center">Sale is <span className="text-success">Live!</span></div>
                <label className="px-5">Enter amount to mint-</label>
                <form onSubmit={this.onClickHandler}>
                    <div className="d-flex px-5">
                        <div className="flex-grow-1 form-group">
                            <input className="form-control bg-dark text-light some-number" type="number" min="1" max="10" step="1" placeholder={"Maximum "+this.state.max_purchase+" per transaction"} onChange={this.updateInput} />
                        </div>
                        <div className="px-3 text-left form-group">
                            <button type="submit" className="btn btn-light btn-rounded" ><span>Mint</span></button>
                        </div>
                    </div>
                </form>
                <div className='text-cream text-center' style={{fontSize:'18px'}}>
                Mint Remaining : {this.state.max_tokens-this.state.current_supply}/{this.state.max_tokens}
                </div>
            </div>
        )
    }

    saleEnded(){
        return(
            <div>
                <Gallery windowSize="300px" gallerySize="8000px" />
                <div className='lato-black text-center text-light'>
                    <span className="text-mint">Sold </span>Out<br />
                    <div className="text-cream lato-regular">Trade in Opensea <a href="https://opensea.io/" target='_blank' rel="noopener noreferrer"><small><i class="fas fa-external-link-alt text-white"></i></small></a></div>
                </div>
            </div>
        )
    }

    async componentDidMount() {
        if (typeof window.ethereum == 'undefined') {
            console.log('Wallet not connected')
        } else {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const contract = new ethers.Contract(contractAddress, Pandu.abi, provider)
            try {
                const issaleactive = await contract.saleIsActive()
                const currentSupply = await contract.totalSupply()
                const maxTokens = await contract.MAX_TOKENS()
                const currentPrice = await contract.CURRENT_PRICE()
                const maxPurchase = await contract.MAX_PURCHASE()

                console.log('Sale Is Active: ', issaleactive)
                console.log('Current Supply', currentSupply.toNumber())
                console.log('Maximum Supply', maxTokens.toNumber())
                console.log('Sale Price', currentPrice/10**18)
                console.log('Max Purchase', maxPurchase.toNumber())

                this.setState({
                    max_tokens: maxTokens.toNumber(),
                    max_purchase: maxPurchase.toNumber(),
                    current_supply: currentSupply.toNumber(),
                    current_price: currentPrice/10**18,
                    is_sale_active: issaleactive,
                })

            } catch (err) {
                console.log("Error: ", err)
            }
            console.log(this.state.max_tokens-this.state.current_supply)
        }
    }

    render() {
        return (
            <div>
                <div className="mt-3">
                    {this.state.is_sale_active ? ((this.state.max_tokens-this.state.current_supply>0)?this.saleActive():this.saleEnded()) : this.saleInactive()}
                </div>
            </div>
        );
    }
}


export default Sale;
